export default __webpack_public_path__ + "static/media/advantage_bg.34b3494d.png";